import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NamedItemInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const TiBasic = (props: {rowData: [], field: string, defaults: {}, namedItems: {}, persist: Function}) => {
  const emptyRecord = {
    new: null,
    renewal: null,
    amtType: props.defaults["tiAmtType"],
    inflation: {
      inflationMode: "namedItem",
      inflationNamedItemId: _.get(props, "defaults.tiInflation.inflationNamedItemId")
    },
    payout: {
      payoutMode: "namedItem",
      payoutNamedItemId: _.get(props, "defaults.tiPayout.payoutNamedItemId")
    }
  }
  if(_.includes(props.defaults["tiAmtType"], "%")) _.set(emptyRecord, "inflation", null)

  const [data, setData] = useState<object|null>(props.rowData[props.field]);

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    if (!field.includes('NamedItemId')) nextData[field] = val

    if (!nextData['amtType']) nextData['amtType'] = props.defaults['tiAmtType']
    if (field === 'inflationNamedItemId'){
      nextData['inflation'] = { inflationMode: 'namedItem', inflationNamedItemId: val }
    }
    if (field === 'payoutNamedItemId'){
      nextData['payout'] = { payoutMode: 'namedItem', payoutNamedItemId: val }
    }
    if (!nextData['inflation']){
      nextData['inflation'] = { inflationMode: 'namedItem', inflationNamedItemId: props.defaults['tiInflation']['inflationNamedItemId'] }
    }
    if (!nextData['payout']){
      nextData['payout'] = { payoutMode: 'namedItem', payoutNamedItemId: props.defaults['tiPayout']['payoutNamedItemId'] }
    }
    if(field === "amtType" && _.includes(val, "%")) {
      _.set(nextData, field, val)
      _.set(nextData, "inflation", null)
    }

    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'tidetail', props.rowData)
  }

  const attrs = (field) => field_attrs('marketlease', props.field)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>New</label>
          <NumberInput
            field="new"
            className="automated billion-input"
            data={data}
            attrs={attrs}
            min={0}
            max={1000000000}
            readPrecision={4}
            writePrecision={4}
            persist={updateData}
          />
        </div>
        <div>
          <label>Renewal</label>
          <NumberInput
            field="renewal"
            className="automated billion-input"
            data={data}
            attrs={attrs}
            min={0}
            max={1000000000}
            readPrecision={4}
            writePrecision={4}
            persist={updateData}
          />
        </div>
        <div>
          <label>Amt Type</label>
          <DropdownInput
            field="amtType"
            className="automated ti-basic-ni"
            data={data}
            attrs={attrs}
            default={props.defaults['tiAmtType']}
            options={['Amt', 'Amt/Area', '% of Rent', '% of Rent + Recovery', '% of Rent: Ignore Free', '% of All Revenues']}
            persist={updateData}
          />
        </div>
        <div>
          <label>Inflation</label>
          <NamedItemInput
            className="automated ti-basic-ni"
            data={data?.['inflation']}
            attrs={attrs}
            field="inflationNamedItemId"
            filter={true}
            default={_.includes(_.get(data, "amtType"), "%") ? null : props.defaults['tiInflation']['inflationNamedItemId']}
            disabled={_.includes(_.get(data, "amtType"), "%")}
            options={props.namedItems['inflation']}
            persist={updateData}
          />
        </div>
        <div>
          <label>Payout</label>
          <NamedItemInput
            className="automated ti-basic-ni"
            data={data?.['payout']}
            attrs={attrs}
            field="payoutNamedItemId"
            filter={true}
            default={props.defaults['tiPayout']['payoutNamedItemId']}
            options={props.namedItems['payout']}
            persist={updateData}
          />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default TiBasic
